<template>
  <el-container>
    <el-aside width="150px">
      <div class="logo">
        <img src="../../src/assets/img/logo.png" alt="logo" />
      </div>
      <el-menu default-active="/payment" class="el-menu-vertical-demo" text-color="#fff" active-text-color="#fff"
        router>

        <el-menu-item index="/home" :class="['aside-item',asideId == '0001' ? 'aside-item-active' : '',]"
          @click="">
          <img :src='require("../../src/assets/img/home.png")' style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">系统首页</span>
        </el-menu-item>
        <el-menu-item index="/merchant" :class="['aside-item',asideId == '0002' ? 'aside-item-active' : '',]"
          @click="">
          <img :src='require("../../src/assets/img/merchant.png")' style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">零售商户</span>
        </el-menu-item>
        <!-- <el-menu-item index="/cyAdmin" :class="['aside-item',asideId == '0015' ? 'aside-item-active' : '',]"
          @click="">
          <img :src='require("../../src/assets/img/merchant.png")' style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">餐饮商户</span>
        </el-menu-item> -->
        <el-menu-item index="/partner" :class="['aside-item',asideId == '0003' ? 'aside-item-active' : '',]"
          @click="">
          <img :src='require("../../src/assets/img/partner.png")' style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">下级代理</span>
        </el-menu-item>
        <!-- <el-menu-item index="/orgFrMx" :class="['aside-item',asideId == '0014' ? 'aside-item-active' : '',]"
          @click="fAsideChoose('0014', '分润管理', '/orgFrMx')">
          <img :src='require("../../src/assets/img/orgFrMx.png")' style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">分润管理</span>
        </el-menu-item> -->

        <el-menu-item :index="item.a_path" v-for="item in asideList" :key="item.a_id" :class="[
            'aside-item',
            asideId == item.a_id ? 'aside-item-active' : '',
          ]" @click="">
          <img :src="item.icon" style="width: 15px; height: 15px" class="x-m-r-10" />
          <span slot="title">{{ item.a_name }}</span>
        </el-menu-item>
        <el-menu-item class="aside-item">
          <img src="../assets/img/download.png" style="width: 15px; height: 15px" class="x-m-r-10" />
          <a slot="title" target="_blank" href="https://www.sanmipos.com/smgw/download.html">软件下载</a>
        </el-menu-item>
        <el-menu-item class="aside-item">
          <img src="../assets/img/payment.png" style="width: 15px; height: 15px" class="x-m-r-10" />
          <a slot="title" target="_blank" href="https://www.sanmipos.com/smpay/partnerAdmin/#/login">支付进件</a>
        </el-menu-item>
        <el-menu-item class="aside-item">
          <img src="../assets/img/duty.png" style="width: 15px; height: 15px" class="x-m-r-10" />
          <a slot="title" target="_blank" href="https://soft.sanmipos.com/smUnionPlatform/index.html">值守管理</a>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header height="7vh">
        <div class="left">{{ asideName }}</div>
        <div class="right">
          <div>
            <img src="../assets/img/user_logo.png" alt="" />
          </div>
          <el-dropdown>
            <span class="el-dropdown-link">
              {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="modifyPwdDislog = !modifyPwdDislog">修改密码</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="logout">注销登录</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="" :visible.sync="modifyPwdDislog" width="500px" :close-on-click-modal="false">
      <div class="x-flex x-row-center x-font-16 f600 x-m-b-30">修改密码</div>
      <el-row class="x-m-t-15">
        <el-col class="x-flex x-p-r-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">旧密码</div>
          <el-input type="text" v-model="oldPwd" size="small"></el-input>
        </el-col>
        <el-col class="x-flex x-p-r-15 x-m-t-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">新密码</div>
          <el-input type="text" v-model="newPwd" size="small" show-password></el-input>
        </el-col>
        <el-col class="x-flex x-p-r-15 x-m-t-15" :span="24">
          <div class="x-w90 x-text-r x-p-r-15">确认密码</div>
          <el-input type="text" v-model="confirmPwd" size="small" show-password></el-input>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="fEditPwdClose" size="small">取 消</el-button>
        <el-button type="primary" @click="fSaveEditPwd" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
      return {
        userName: "",
        path: "/merchant",
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
        asideList1: [
          // {
          //     a_id: "0001",
          //     a_name: "系统首页",
          //     a_path: "/home",
          //     a_component: "home",
          //     icon: require("../../src/assets/img/home.png"),
          //   },
          //   {
          //     a_id: "0002",
          //     a_name: "商户管理",
          //     a_path: "/merchant",
          //     a_component: "merchant",
          //     icon: require("../../src/assets/img/merchant.png"),
          //   },
          //   {
          //     a_id: "0003",
          //     a_name: "下级代理",
          //     a_path: "/partner",
          //     a_component: "partner",
          //     icon: require("../../src/assets/img/partner.png"),
          //   },
          {
            a_id: "0010",
            a_name: "产品码库",
            a_path: "/codeManger",
            a_component: "codeManger",
            icon: require("../../src/assets/img/codeManger.png"),
          },
          {
            a_id: "0015",
            a_name: "设备SN",
            a_path: "/snCode",
            a_component: "snCode",
            icon: require("../../src/assets/img/codeManger.png"),
          },
          // {
          //   a_id: "0005",
          //   a_name: "问题提交",
          //   a_path: "/problem",
          //   a_component: "problem",
          //   icon: require("../../src/assets/img/problem.png"),
          // },
          // {
          //   a_id: "0003",
          //   a_name: "软件下载",
          //   icon: require("../../src/assets/img/payment.png"),
          // },
          // {
          //   a_id: "0004",
          //   a_name: "支付进件",
          //   a_path: "/payment",
          //   a_component: "payment",
          //   icon: require("../../src/assets/img/payment.png"),
          // },
          // {
          //   a_id: "0005",
          //   a_name: "员工档案",
          //   a_path: "/user",
          //   a_component: "user",
          //   icon: require("../../src/assets/img/user.png"),
          // },
          {
            a_id: "0006",
            a_name: "微信设置",
            a_path: "/wxOption",
            a_component: "wxOption",
            icon: require("../../src/assets/img/wxoption.png"),
          },
          {
            a_id: "0007",
            a_name: "人脸识别",
            a_path: "/smFace",
            a_component: "smFace",
            icon: require("../../src/assets/img/smFace.png"),
          },

          {
            a_id: "0008",
            a_name: "AI商户库",
            a_path: "/smAi",
            a_component: "smAi",
            icon: require("../../src/assets/img/smAi.png"),
          },
          // {
          //   a_id: "0009",
          //   a_name: "消息管理",
          //   a_path: "/msgAdmin",
          //   a_component: "msgAdmin",
          //   icon: require("../../src/assets/img/smAi.png"),
          // },
          {
            a_id: "0011",
            a_name: "商店订单",
            a_path: "/smShopOrder",
            a_component: "smShopOrder",
            icon: require("../../src/assets/img/smFace.png"),
          },
          {
            a_id: "0012",
            a_name: "外卖商户",
            a_path: "/takeaway",
            a_component: "takeaway",
            icon: require("../../src/assets/img/takeaway.png"),
          },
          {
            a_id: "0013",
            a_name: "抖音商户",
            a_path: "/douyinMch",
            a_component: "douyinMch",
            icon: require("../../src/assets/img/douyinMch.png"),
          },
          {
            a_id: "0014",
            a_name: "分润管理",
            a_path: "/orgFrMx",
            a_component: "orgFrMx",
            icon: require("../../src/assets/img/orgFrMx.png"),
          },

        ],
        asideList: [],
        asideId: "",
        asideName: "",
        modifyPwdDislog: false, // 修改密码的弹窗
      };
    },
    computed: {
      key() {
        return this.$route.path + Math.random();
      },
    },
    created() {
      // let defaultMenu = window.location.hash.substr(
      //   window.location.hash.indexOf("/")
      // );
      this.fSetActive()
      this.eventBus.$on('share', (e) => {
        console.log(e, 'share')
        this.fSetActive()
        // this.path = sessionStorage.path;
        // this.asideId = sessionStorage.id;
        // this.asideName = sessionStorage.name;
      })
      let data = JSON.parse(localStorage.bykPlatform).partnerInfo.data;
      this.userName = data.comp_name;

      // this.path = sessionStorage.path;
      // this.asideId = sessionStorage.id;
      // this.asideName = sessionStorage.name;
      let title = document.getElementsByTagName("title")[0];
      // title.innerText = "贝友客合作伙伴平台";
      // if (data.user_phone != '18957102098' && data.user_phone != '4006908190') {
      //   this.asideList.forEach((item, index) => {
      //     if (item.a_name == '消息管理' || item.a_name == '微信设置' || item.a_name == '人脸识别' || item.a_name == '商城订单') {
      //       this.asideList.splice(index, 1)
      //     }
      //   })

      // }
      if (data.user_phone == '18957102098') {
        this.asideList = this.asideList1
        return
      } else {
        let authArr = []
        if (!this.bykApi.smCom.fSmIsEmpty(this.bykApi.global.fGetPlatform().partnerInfo.data.auth_info)) {
          authArr = JSON.parse(this.bykApi.global.fGetPlatform().partnerInfo.data.auth_info);
        }
        let result = this.asideList1.filter(item => authArr.includes(item.a_name));
        // console.log(result)
        // console.log()
        this.asideList = result
      }

    },
    watch: {
      '$route': 'fSetActive', //监听路由变化
    },
    methods: {
      //设置选中状态
      fSetActive(type) {
        // 获取地址栏中的路由
        let defaultMenu = window.location.hash.substr(
          window.location.hash.indexOf("/")
        );
        defaultMenu = defaultMenu.split('?')[0]
        console.log(defaultMenu)
        if (defaultMenu == '/home') {
          this.path = '/home';
          this.asideId = '0001';
          this.asideName = '系统首页';
          return
        }
        if (defaultMenu == '/merchant') {
          this.path = '/merchant';
          this.asideId = '0002';
          this.asideName = '零售商户';
          return
        }
        if (defaultMenu == '/cyAdmin') {
          this.path = '/cyAdmin';
          this.asideId = '0015';
          this.asideName = '餐饮商户';
          return
        }
        if (defaultMenu == '/partner') {
          this.path = '/partner';
          this.asideId = '0003';
          this.asideName = '下级代理';
          return
        }
        this.asideList.forEach((item) => {
          if (item.a_path == defaultMenu) {
            this.asideId = item.a_id;
            this.asideName = item.a_name;
            this.path = item.a_path;
          }
        })
      },
      fAsideChoose(id, name, path) {

        // this.asideId = id;
        // this.asideName = name;
        // sessionStorage.setItem("path", path);
        // sessionStorage.setItem("id", id);
        // sessionStorage.setItem("name", name);
      },
      // 注销登录
      logout() {
        localStorage.removeItem("bykPlatform");
        this.$router.push("/login");
      },
      async fSaveEditPwd() {
        if (this.bykApi.smCom.fSmIsEmpty(this.oldPwd)) {
          return this.$message("请输入旧密码");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.newPwd)) {
          return this.$message("请输入新密码");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.confirmPwd)) {
          return this.$message("请输入确认密码");
        }
        if (this.newPwd != this.confirmPwd) {
          return this.$message("两次新密码不一致");
        }
        let res = await this.fBykGetPartnerChgPsw();
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message(res.msg);
        this.fEditPwdClose();
        return;
      },

      // 取消修改密码
      fEditPwdClose() {
        this.oldPwd = "";
        this.newPwd = "";
        this.confirmPwd = "";
        this.modifyPwdDislog = false;
      },

      // ------------ 请求 开始 -------------

      // 修改密码
      async fBykGetPartnerChgPsw() {
        let js = {};
        js["PARTNER_PHONE"] = this.bykApi.global.fGetPlatform().partnerInfo.phone;
        js["OLD_PSW"] = this.oldPwd;
        js["NEW_PSW"] = this.newPwd;
        // let res = await this.bykApi.postApi.fPostToBykPlatFormoApi(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_CHG_PSW', js);
        return res;
      },

      // ------------ 请求 结束 -------------
    },
  };
</script>

<style lang="less" scoped>
  .el-aside {
    font-size: 16px;
    height: 100vh;
    background-color: #242d37;

    //   font-weight: bold;
    .logo {

      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: auto;
        height: 50px;
      }
    }

    .aside-item {
      a {
        color: #f2f2f2;
      }

      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // padding-left: 30px;
    }

    .aside-item-active {
      background-color: #409eff;
    }
  }

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;

    .right {
      display: flex;
      align-items: center;
      font-weight: 500;

      img {
        width: 30px;
        margin-right: 10px;
        height: 30px;
        border-radius: 50%;
        background-color: rgb(138, 138, 138);
      }
    }

    .right:hover {
      .edit-pwd {
        display: flex;
      }
    }
  }

  .el-main {
    background-color: #f5f5f5;
    padding: 8px 8px 0;
  }

  /deep/ .el-menu {
    border: 0;
    background-color: #242d37;
  }

  /deep/ .el-menu-item:hover {
    background-color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue